if($('.homepage-blog-wrapper').length){
    $('.homepage-blog-wrapper .homepage-group-title').replaceWith($('footer#footer .newHomepageBlog'))
}